"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Empresa = void 0;
const typeorm_1 = require("typeorm");
const base_entity_1 = require("sol-orm-ts/dist/base-entity");
const pessoa_juridica_entity_1 = require("./pessoa-juridica.entity");
let Empresa = class Empresa extends base_entity_1.CustomBaseEntity {
    constructor() {
        super(...arguments);
        this.cdEmpresa = void (0);
        this.lgMatriz = void (0);
        this.imgLogomarca = void (0);
        this.idEmpresa = void (0);
        this.cdTabelaCatEconomica = void (0);
        this.pessoaJuridica = void (0);
    }
};
__decorate([
    typeorm_1.Column("integer", { primary: true, name: "cd_empresa", nullable: true }),
    __metadata("design:type", Number)
], Empresa.prototype, "cdEmpresa", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "lg_matriz", nullable: true }),
    __metadata("design:type", Number)
], Empresa.prototype, "lgMatriz", void 0);
__decorate([
    typeorm_1.Column("blob", { name: "img_logomarca", nullable: true }),
    __metadata("design:type", Object)
], Empresa.prototype, "imgLogomarca", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "id_empresa", nullable: true }),
    __metadata("design:type", String)
], Empresa.prototype, "idEmpresa", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_tabela_cat_economica", nullable: true }),
    __metadata("design:type", Number)
], Empresa.prototype, "cdTabelaCatEconomica", void 0);
__decorate([
    typeorm_1.OneToOne(type => pessoa_juridica_entity_1.PessoaJuridica, {
        cascade: ['insert', 'update', 'remove']
    }),
    typeorm_1.JoinColumn([{ name: "cd_empresa", referencedColumnName: "cdPessoa" }]),
    __metadata("design:type", pessoa_juridica_entity_1.PessoaJuridica)
], Empresa.prototype, "pessoaJuridica", void 0);
Empresa = __decorate([
    typeorm_1.Entity('grl_empresa')
], Empresa);
exports.Empresa = Empresa;
